function NotFound() {
    return <div className="first-component flex justify-center items-center bg-background-dark flex-col">
        <p className="md:text-big text-medium font-elegant">404</p>
        <p className="md:text-big text-medium font-elegant">Parece que esta pagina no existe :(</p>
    </div>
}

export default NotFound